import baseService from '../shared/baseService';

const powerBIService = () => baseService('dashboards');
const influencerPowerBIService = () => baseService('influencer/dashboards');
const influencerBoticarioPowerBIService = () =>
  baseService('influencer/dashboards/boticario');
const colgatePowerBIService = () => baseService('colgate/dashboards');

export default {
  powerBIService,
  influencerPowerBIService,
  influencerBoticarioPowerBIService,
  colgatePowerBIService,
};
